export const state = () => ({
	// interviews: null,
	offer: null,
	counter: false,
	confirm: false,
	// cursor: null,
});

export const mutations = {
	// setInterviews(state: any, payload: any) {
	// 	state.interviews = payload;
	// },
	setOffer(state: any, payload: any) {
		state.offer = payload;
	},
	setCounter(state: any, payload: any) {
		state.counter = payload;
	},
	setConfirm(state: any, payload: any) {
		state.confirm = payload;
	},
};

export const getters = {
	// getInterviews: (state: any) => state.interviews,
	getOffer: (state: any) => state.offer,
	getCounter: (state: any) => state.counter,
	getConfirm: (state: any) => state.confirm,
};

export const actions = {
	respondToOffer(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.put('/api/offers/' + payload.uuid, payload.data)
				.then((res) => {
					resolve(res.status);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	// updateInterviews(state: any, payload: any) {
	// 	state.commit('setInterviews', payload);
	// },
	//
	updateOffer(state: any, payload: any) {
		state.commit('setOffer', payload);
	},
	updateCounter(state: any, payload: any) {
		state.commit('setCounter', payload);
	},
	updateConfirm(state: any, payload: any) {
		state.commit('setConfirm', payload);
	},
	//
	// updateCursor(state: any, payload: any) {
	// 	state.commit('setCursor', payload);
	// },
};
